export enum MenuOption {
  Contact = "Contact",
  Password = "Password",
  Billing = "Plan & Billing",
  Users = "Users",
  Advanced = "Advanced",
}
